import React, { useCallback, useState } from "react";
import Subtitle from "@radarly/components/cards/card/subtitle";
import ImageCredentialsStatus from "@radarly/components/widgets/picture-wall/status";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { getDateFromClause } from "@radarly/models/clause/getter";
import { refineClauseWithInnerClause } from "@radarly/models/clause/refiner";
import { DatavizImageClustering } from "@radarly/models/dataviz";
import { Cluster } from "@radarly/models/insights";
import { SearchFragmentPosts } from "@radarly/models/search";
import Date from "@radarly/shared/cards/subtitle/date";
import Tile from "@radarly/shared/cards/tile";
import ImageClustering from "@radarly/shared/widgets/cluster/image-clustering";
import { CardFragmentProps } from "../model";

const RadarlyPostsCardsImageClustering = ({
  title,
  fragment,
  height,
  openPostsPanel,
  timezone,
  forceReload,
  nowDate,
}: CardFragmentProps<SearchFragmentPosts, DatavizImageClustering>) => {
  const locale = useCurrentUserLocale();
  const fullProject = useCurrentProject();
  const [cluster, setCluster] = useState<Cluster>(null);
  const { from, to } = getDateFromClause(fragment.request.query);

  const onClickItem = useCallback(
    (uids: string[]) => {
      openPostsPanel({
        clause: refineClauseWithInnerClause(fragment.request.query, {
          docIds: { in: uids, not: [] },
        }),
        period: { from, to },
        title,
        timezone,
      });
    },
    [fragment.request.query, from, openPostsPanel, timezone, title, to]
  );

  return (
    <Tile
      title={title}
      height={height}
      subtitle={
        <Subtitle
          meta={[
            <Date fragment={fragment} timezone={timezone} nowDate={nowDate} />,
            <span>{tr(locale, "METRICS::DOC")}</span>,
          ]}
        />
      }
      statusInfo={
        <ImageCredentialsStatus project={fullProject} locale={locale} />
      }
      clause={fragment.request.query}
    >
      <ImageClustering
        fragment={fragment}
        onClick={openPostsPanel ? onClickItem : null}
        forceReload={forceReload}
        period={{ from, to }}
        height={height}
        clusterView={cluster}
        onChangeClusterView={setCluster}
      />
    </Tile>
  );
};

export default RadarlyPostsCardsImageClustering;
